var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("color: white; background-color:" + _vm.bgColor + "; border-radius: 12px; padding: 8px 22px; font-size: 14px; " + _vm.styleCustom))},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }